import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosConn from '../../axiosConn';
import { safeText } from '../localopsProofPortfolio/proofPortfolioUtils';

const PROOF_AVAILABILITY_LIMIT = 1;

export default function LocalOpsProfileProofPill({
  profilePlayerId,
  isSelf = false,
}) {
  const [hasProofs, setHasProofs] = useState(false);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const publicPlayerId = safeText(profilePlayerId);
    if (!publicPlayerId) {
      setHasProofs(false);
      setFailed(false);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setFailed(false);

    axiosConn
      .get(`local-ops/players/${encodeURIComponent(publicPlayerId)}/proofs`, {
        params: { limit: PROOF_AVAILABILITY_LIMIT },
      })
      .then((res) => {
        if (cancelled) return;
        const proofs = Array.isArray(res?.data?.data?.proofs)
          ? res.data.data.proofs
          : [];
        setHasProofs(proofs.length > 0);
      })
      .catch(() => {
        if (cancelled) return;
        setHasProofs(false);
        setFailed(true);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [profilePlayerId]);

  if (failed) return null;
  if (!loading && !hasProofs && !isSelf) return null;

  const proofPortfolioPath = `/profile/${encodeURIComponent(
    safeText(profilePlayerId),
  )}/proofs`;
  const desktopLabel = hasProofs ? 'LocalOps Proofs' : 'Build Proofs';
  const mobileLabel = desktopLabel;
  const desktopStatus = loading
    ? 'Checking'
    : hasProofs
      ? 'Recent proof'
      : 'Proof ready';
  const mobileStatus = loading ? 'Checking' : hasProofs ? 'Verified' : 'Start';
  const accessibleLabel = 'Verified LocalOps Proofs';

  return (
    <Link
      className="localops-profile-proof-pill"
      data-testid="localops-profile-proof-pill"
      aria-label={accessibleLabel}
      to={proofPortfolioPath}
    >
      <span className="localops-profile-proof-pill__label localops-profile-proof-pill__label--full">
        {desktopLabel}
      </span>
      <span className="localops-profile-proof-pill__label localops-profile-proof-pill__label--short">
        {mobileLabel}
      </span>
      <strong className="localops-profile-proof-pill__chip localops-profile-proof-pill__chip--full">
        {desktopStatus}
      </strong>
      <strong className="localops-profile-proof-pill__chip localops-profile-proof-pill__chip--short">
        {mobileStatus}
      </strong>
    </Link>
  );
}
